/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZohoServiceDeskPolicyMapping {
    getFixupPrototypeFunction() { return ZohoServiceDeskPolicyMapping.fixupPrototype; }

    static newInstance(model: Partial<ZohoServiceDeskPolicyMapping>): ZohoServiceDeskPolicyMapping {
        let obj = Object.assign(new ZohoServiceDeskPolicyMapping(), model);
        ZohoServiceDeskPolicyMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZohoServiceDeskPolicyMapping>): ZohoServiceDeskPolicyMapping {
        if (!model) return null;
        return ZohoServiceDeskPolicyMapping.newInstance(<ZohoServiceDeskPolicyMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZohoServiceDeskPolicyMapping) {
        if (!obj) return;

        models.ZohoServiceDeskPolicyMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZohoServiceDeskPolicyMapping): boolean {
        Object.setPrototypeOf(obj, ZohoServiceDeskPolicyMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    selected_description_attributes: Array<models.ZohoServiceDeskPolicyDescriptionAttribute>;

    selected_incident_attributes: Array<models.ZohoServiceDeskPolicyIncidentAttribute>;

}
